import { LoadingList } from '@/core/components/LoadingList'
import {
  isManualRestriction,
  RESTRICTION_WRITE_ROLES,
} from '@/core/components/sites/site/restrictions/restriction-filters'
import { getRestrictions } from '@/core/components/sites/site/restrictions/restrictionsQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/restrictions/$restrictionId/edit/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (!RESTRICTION_WRITE_ROLES.includes(auth.user?.role ?? '')) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  // The API has no GET by id, so the row comes from the site list. fetchQuery,
  // not ensureQueryData: the PUT replaces the whole row, so editing a cached
  // copy would silently undo another admin's later change. Channel rows are
  // read-only (403 on PUT), so a hand-typed URL to one goes back to the list.
  loader: async ({ context: { queryClient, auth }, params }) => {
    const list = await queryClient.fetchQuery({
      ...getRestrictions(params.siteId, auth.token!),
      staleTime: 0,
    })
    const restriction = list.data.find((r) => r.id === params.restrictionId)
    if (!restriction || !isManualRestriction(restriction)) {
      throw redirect({
        to: '/dashboard/sites/$siteId/restrictions',
        params: { siteId: params.siteId },
        search: {
          page: 1,
          pageSize: 10,
          search: '',
          sortBy: 'type',
          orderBy: 'desc',
        },
      })
    }
    return restriction
  },
  pendingComponent: LoadingList,
})
